import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './vote-arrow.scss';

class VoteArrow extends PureComponent {
  render() {
    const { type, voteAction, active, disabled } = this.props;

    return (
      <div className={classNames('vote-arrow', {
        'vote-arrow--active': active
      })}>
        <div className="vote-arrow__tool-tip">{`Vote ${type}`}</div>
        <button disabled={disabled} className={`vote-arrow__button vote-arrow__button--${type}`} type="button" onClick={() => voteAction(type)} />
      </div>
    );
  }
}

VoteArrow.propTypes = {

};

export default VoteArrow;